import { Outlet } from 'react-router-dom';
import CreateCustomerModal from 'shared/components/CreateCustomerModal';
import CreateResellerModal from 'shared/components/CreateResellerModal';
import Header from 'shared/components/Header';
import Sidebar from 'shared/components/Sidebar';

function Layout() {
  return (
    <>
      <Header />
      <Sidebar>
        <Outlet />
      </Sidebar>
      <CreateCustomerModal />
      <CreateResellerModal />
    </>
  );
}

export default Layout;
